__turbopack_context__.v({
  "chevron": "TicketStack-module__0sIv-a__chevron",
  "chevronButton": "TicketStack-module__0sIv-a__chevronButton",
  "chevronButtonRotated": "TicketStack-module__0sIv-a__chevronButtonRotated",
  "container": "TicketStack-module__0sIv-a__container",
  "group": "TicketStack-module__0sIv-a__group",
  "groupLabel": "TicketStack-module__0sIv-a__groupLabel",
  "skeletonContainer": "TicketStack-module__0sIv-a__skeletonContainer",
  "skeletonWrapper": "TicketStack-module__0sIv-a__skeletonWrapper",
  "ticketLoaded": "TicketStack-module__0sIv-a__ticketLoaded",
  "ticketWrapper": "TicketStack-module__0sIv-a__ticketWrapper",
});
